import React from 'react';

import { Modal } from '@opendoor/bricks';
import { humanizedRepairPreferences } from '../../constants/RepairPreferenceConstants';
import { IBuyerRepairPreference } from '../../declarations';

import './RepairPreferencesModalStyle.less';

export interface IRepairPreferencesModalProps {
  buyerRepairPreferences: IBuyerRepairPreference | null;
  isOpen: boolean;
  onRequestClose: () => void;
}

export default class RepairPreferencesModal extends React.PureComponent<
  IRepairPreferencesModalProps
> {
  public render(): JSX.Element {
    const { buyerRepairPreferences, isOpen, onRequestClose } = this.props;
    const repairPreferenceNotes = buyerRepairPreferences && buyerRepairPreferences.notes;
    const preferredSellerResponse =
      buyerRepairPreferences && buyerRepairPreferences.preferred_seller_response;
    return (
      <Modal
        className="resale-closing-dashboard-repair-preferences-modal"
        isOpen={isOpen}
        onRequestClose={onRequestClose}
      >
        <div className="repair-preference-modal-header">Repair priorities</div>
        <div className="repair-preference-modal-body">
          <div className="repair-preference-label">
            What type of response would your buyer prefer?
          </div>
          <div className="repair-preference-response">
            {humanizedRepairPreferences[preferredSellerResponse] || '-'}
          </div>
          <div className="repair-preference-label">
            Which repair items are most important to your buyer?
          </div>
          <div className="repair-preference-response">
            {(repairPreferenceNotes && repairPreferenceNotes.trim()) || '-'}
          </div>
        </div>
      </Modal>
    );
  }
}
